import React from 'react';
import { Search } from 'lucide-react';
import { cn } from '@/lib/utils';
import Icon from './Icon';

interface SearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  /** Accessible name when the placeholder isn't descriptive enough. */
  label?: string;
  className?: string;
}

/** 44px search input with a leading magnifier (Figma "Search field"). */
const SearchField: React.FC<SearchFieldProps> = ({ value, onChange, placeholder, label, className }) => (
  <label
    className={cn(
      'tw-flex tw-h-11 tw-items-center tw-gap-2.5 tw-rounded-xl tw-border tw-border-ds-border-default tw-bg-ds-surface tw-px-[14px] tw-transition-colors focus-within:tw-border-ds-brand',
      className,
    )}
  >
    <Icon icon={Search} className="tw-text-ds-text-tertiary" />
    <input
      type="search"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      aria-label={label ?? placeholder}
      className="tw-min-w-0 tw-flex-1 tw-border-0 tw-bg-transparent tw-p-0 tw-text-[14px] tw-leading-5 tw-text-ds-text-primary tw-outline-none placeholder:tw-text-ds-text-tertiary"
    />
  </label>
);

export default SearchField;
